// Touch devices: a horizontal swipe across a product card's image flips
// between its first and second image (mirroring the desktop hover swap);
// a plain tap still follows the card's link. Cards without a second
// image ignore the swipe. Loaded globally from theme.liquid since cards
// render in many sections.
if (window.matchMedia('(hover: none)').matches) {
  let startX = 0;
  let startY = 0;
  let media = null;
  let swiped = false;

  document.addEventListener(
    'pointerdown',
    (event) => {
      media = event.target.closest('.pcard__media');
      swiped = false;
      if (media) {
        startX = event.clientX;
        startY = event.clientY;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerup',
    (event) => {
      if (!media) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (media.querySelector('.pcard__img--alt')) {
          media.classList.toggle('show-alt');
          swiped = true;
        }
      }
      media = null;
    },
    { passive: true }
  );

  // If the browser still dispatches a click after the swipe gesture,
  // swallow it so the product page doesn't open.
  document.addEventListener(
    'click',
    (event) => {
      if (swiped && event.target.closest('.pcard')) {
        event.preventDefault();
        swiped = false;
      }
    },
    true
  );
}
